import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import styles from './content-wrapper.module.css'

export type ContentWrapperProps = ComponentPropsWithoutRef<'div'>

export function ContentWrapper({
  className,
  children,
  ...rest
}: ContentWrapperProps): ReactElement {
  return (
    <div className={clsx(styles.contentWrapper, className)} {...rest}>
      {children}
    </div>
  )
}
